module.exports = __webpack_public_path__ + "static/gallery9-ea99e54e945297e8f08d6b01416f3345.jpg";